import * as React from 'react';
import { SVGProps } from 'react';

const IconIpadStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2Zm16 2H3v12h15V6Z"
    />
  </svg>
);
export default IconIpadStrokedSizeM;
